/* A/B test tracking (Shopify Rollouts experiments).
   Reads #ec-ab-config emitted by snippets/ec-ab-tracking.liquid.
   1) Stamps cart attribute _ab = "<test>-<variant>" once per session on load
      (survives the buy-it-now instant-redirect flow) and re-checks on cart
      events as backup.
   2) Tags the Clarity session so recordings/heatmaps filter by variant. */
(function () {
  var cfgEl = document.getElementById('ec-ab-config');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (err) { return; }
  if (!cfg.test) return;

  /* Variant detection (Jul 16): in Rollouts' gradual-rollout mode both buckets
     serve the SAME theme, so the server-side variant is unreliable. The tested
     change itself is the ground truth: the offer widget renders
     data-ot-auto-highest="1" only in the treatment bucket. Detect it on any
     page that has the widget, persist per test, and skip stamping for
     visitors whose bucket is still unknown (they have not seen the tested
     widget, so they are outside the measured audience anyway). */
  var LS_VAR = 'ec_ab_variant:' + cfg.test;
  var variant = null;
  var sig = document.querySelector('[data-ot-auto-highest]');
  if (sig) {
    variant = sig.getAttribute('data-ot-auto-highest') === '1' ? 'B' : 'A';
    try { localStorage.setItem(LS_VAR, variant); } catch (err) {}
  } else {
    try { variant = localStorage.getItem(LS_VAR); } catch (err) {}
  }
  if (!variant) return;

  var tag = cfg.test + '-' + variant;
  var LS_KEY = 'ec_ab_stamped';
  window.__ecAb = tag; // QA convenience

  function stamped() {
    try { return sessionStorage.getItem(LS_KEY) === tag; } catch (err) { return false; }
  }
  function markStamped() {
    try { sessionStorage.setItem(LS_KEY, tag); } catch (err) {}
  }

  var inFlight = false;
  function stamp() {
    if (inFlight || stamped()) return;
    inFlight = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { _ab: tag } })
    }).then(function (res) {
      if (res.ok) markStamped();
    }).catch(function () {}).finally(function () { inFlight = false; });
  }

  document.addEventListener('cart:item-added', stamp);
  document.addEventListener('cart:updated', stamp);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stamp);
  } else {
    stamp();
  }

  // Clarity loads async (app embed) — retry until its queue stub exists.
  var tries = 0;
  (function tagClarity() {
    if (window.clarity) {
      window.clarity('set', 'ab_test', tag);
    } else if (tries++ < 60) {
      setTimeout(tagClarity, 500);
    }
  })();
})();
